var Model = require("../types/Model.js");
import Orientation from "react-native-orientation-locker";

module.exports = new Model({
	name: "orientation",
	init: init,
	uninit: uninit,
	_orientationDidChange: null,
	handleChange: handleChange
});

function init() {
	this._orientationDidChange = handleChange.bind(this);

	Orientation.getOrientation(gotOrientation.bind(this));

	Orientation.addOrientationListener(this._orientationDidChange);
}

function gotOrientation(err, orientation) {
	if(err) return;
	this.handleChange(orientation);
}

function handleChange(orientation) {
	if(this.data === orientation) return;
	this.push(orientation);
	this.dispatch("changed");
}

function uninit(){
	Orientation.removeOrientationListener(this._orientationDidChange);
}
